// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__HRlga","head":"ProcedureTableInfo_head__HSac4"};